import { render, staticRenderFns } from "./ViewManageList.vue?vue&type=template&id=ee0c24e6&scoped=true&"
import script from "./ViewManageList.vue?vue&type=script&lang=js&"
export * from "./ViewManageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0c24e6",
  null
  
)

export default component.exports